import { motion } from "framer-motion";
import { Copy, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import ChapterHeading from "./ChapterHeading";

const IBAN = "IT02G0347501605CC0011279937";

export default function Wishlist() {
  const [copied, setCopied] = useState(false);

  const copyIban = async () => {
    try {
      await navigator.clipboard.writeText(IBAN);
      setCopied(true);
      toast.success("IBAN copiato negli appunti. Grazie di cuore!");
      setTimeout(() => setCopied(false), 2500);
    } catch {
      toast.error("Impossibile copiare, seleziona l'IBAN manualmente.");
    }
  };

  return (
    <section id="lista-nozze" className="px-6 sm:px-12 lg:px-24 py-20 sm:py-28" data-testid="wishlist-section">
      <div className="mx-auto max-w-4xl">
        <ChapterHeading
          number="03"
          title="Lista Nozze"
          kicker="Il regalo più bello è la vostra presenza ma se desiderate contribuire al nostro sogno, ecco le nostre coordinate bancarie."
          testid="wishlist-heading"
        />

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="rounded-2xl border border-sand bg-[#EAE8E2] p-8 sm:p-12"
          data-testid="iban-card"
        >
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <dl className="lg:col-span-8 grid grid-cols-[7rem_1fr] sm:grid-cols-[9rem_1fr] gap-y-4 font-mono text-sm text-charcoal">
              <dt className="text-[10px] uppercase tracking-[0.25em] text-clay self-center">Intestatario</dt>
              <dd className="tracking-wider font-medium">ALESSANDRO FRANCICA</dd>
              <dt className="text-[10px] uppercase tracking-[0.25em] text-clay self-center">IBAN</dt>
              <dd className="text-base sm:text-xl tracking-[0.08em] font-medium break-all" data-testid="iban-value">{IBAN}</dd>
              <dt className="text-[10px] uppercase tracking-[0.25em] text-clay self-center">Conto</dt>
              <dd className="tracking-wider">1279937</dd>
              <dt className="text-[10px] uppercase tracking-[0.25em] text-clay self-center">CAB</dt>
              <dd className="tracking-wider">01605</dd>
              <dt className="text-[10px] uppercase tracking-[0.25em] text-clay self-center">ABI</dt>
              <dd className="tracking-wider">03475</dd>
              <dt className="text-[10px] uppercase tracking-[0.25em] text-clay self-center">BIC/SWIFT</dt>
              <dd className="tracking-wider">INGBITD1XXX</dd>
              <dt className="text-[10px] uppercase tracking-[0.25em] text-clay self-center">Causale</dt>
              <dd className="tracking-wider">Regalo Nozze Federica e Alessandro</dd>
            </dl>
            <div className="lg:col-span-4 flex lg:justify-end">
              <button
                onClick={copyIban}
                className="inline-flex items-center gap-3 rounded-full bg-charcoal text-panna font-mono text-[11px] uppercase tracking-[0.2em] px-7 py-4 transition-all duration-300 hover:bg-terracotta"
                data-testid="iban-copy-button"
              >
                {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
                {copied ? "Copiato" : "Copia IBAN"}
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
